import { LayoutConfig } from '@spartacus/storefront';
import { slbLayoutSlots } from './slb-layout-slots.config';

export const breakpoints: LayoutConfig['breakpoints'] = {
  xs: 576,
  sm: 744,
  md: 992,
  lg: 1200,
  xl: {
    min: 1200,
  },
};

export const slbLayoutConfig: LayoutConfig = {
  layoutSlots: slbLayoutSlots,
  breakpoints,
};
